module.exports = __webpack_public_path__ + "img/icon_integralMall.878038f5.png";